import React, { useState } from "react";
import { createPortal } from "react-dom";
import { FaTrash, FaExclamationTriangle, FaTimes } from "react-icons/fa";

function Hapus({ id, handleDelete }) {
  const [showModal, setShowModal] = useState(false);

  const handleConfirmDelete = () => {
    handleDelete(id);
    setShowModal(false);
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  // Modal Component
  const Modal = () => (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-50 animate__animated animate__fadeIn animate__faster modal-overlay"
        onClick={handleCancel}
      ></div>
      
      {/* Modal Content */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 animate__animated animate__zoomIn animate__faster modal-content">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
              <FaExclamationTriangle className="w-5 h-5 text-red-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900">
              Konfirmasi Hapus
            </h3>
          </div>
          <button
            onClick={handleCancel}
            className="text-gray-400 hover:text-gray-600 transition-colors duration-200 p-1 rounded-full hover:bg-gray-100"
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-gray-600 text-sm leading-relaxed">
            Apakah Anda yakin ingin menghapus item ini? Tindakan ini tidak dapat dibatalkan dan data akan hilang secara permanen.
          </p>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
          <button
            onClick={handleCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all duration-200 hover:scale-105 btn-modern"
          >
            Batal
          </button>
          <button
            onClick={handleConfirmDelete}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-200 hover:scale-105 animate-soft-glow btn-modern"
          >
            Hapus
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="p-2 text-red-600 hover:bg-red-100 rounded-lg transition-all duration-200 hover:scale-110"
        title="Hapus"
      >
        <FaTrash className="w-4 h-4" />
      </button>

      {/* Modal rendered using Portal - outside of component DOM hierarchy */}
      {showModal && createPortal(<Modal />, document.body)}
    </>
  );
}

export default Hapus;
